import React from 'react';
import RadioForm from './../../../../components/RadioForm';

class FumigationProduct extends React.Component{

  constructor() {
    super();
    this.select = this.select.bind(this);
  }

  select(fumigation){
    this.props.selectValue(fumigation);
  }

  render(){
    let optionsFumigationProduct = [{
      id: "telone",
      name: "Telone"
    },{
      id: "chloropicrin",
      name: "Chloropicrin"
    }]

    return (
      <div>
        <RadioForm handler={this.select} formName={"fumigation"} list={optionsFumigationProduct}/>
      </div>
    );
  }
}

export default FumigationProduct;
